import type { ComponentType } from 'react'
import type { TFunction } from 'i18next'
import retrieveAdditionalSalesIcons from '@/shared/icons/retrieveAdditionalSalesIcons'
import IconBoltRounded from '@/shared/icons/NewDesign/IconBoltRounded'
import IconBusinessCenter from '@/shared/icons/NewDesign/IconBusinessCenter'
import IconDomain from '@/shared/icons/NewDesign/IconDomain'
import IconEco from '@/shared/icons/NewDesign/IconEco'
import IconHealthAndSafety from '@/shared/icons/NewDesign/IconHealthAndSafety'
import IconHomeRepairService from '@/shared/icons/NewDesign/IconHomeRepairService'
import IconHomeWork from '@/shared/icons/NewDesign/IconHomeWork'
import IconLocalFireDepartment from '@/shared/icons/NewDesign/IconLocalFireDepartment'
import IconLocalHospital from '@/shared/icons/NewDesign/IconLocalHospital'
import IconLocalShipping from '@/shared/icons/NewDesign/IconLocalShipping'
import IconMedicalServices from '@/shared/icons/NewDesign/IconMedicalServices'
import IconPercent from '@/shared/icons/NewDesign/IconPercent'
import IconRealEstateAgent from '@/shared/icons/NewDesign/IconRealEstateAgent'
import IconReceiptLong from '@/shared/icons/NewDesign/IconReceiptLong'
import IconRouterRounded from '@/shared/icons/NewDesign/IconRouterRounded'
import IconSavings from '@/shared/icons/NewDesign/IconSavings'
import IconSentimentDissatisfied from '@/shared/icons/NewDesign/IconSentimentDissatisfied'
import IconShieldLock from '@/shared/icons/NewDesign/IconShieldLock'
import IconThermostat from '@/shared/icons/NewDesign/IconThermostat'
import IconWaterDrop from '@/shared/icons/NewDesign/IconWaterDrop'
import type { SDIconProps } from '@/shared/icons/SDIcon'

const PRODUCT_ICONS: Record<string, ComponentType<SDIconProps>> = {
  leadAssistance: IconHomeRepairService,
  leadAxaBillProtection: IconReceiptLong,
  leadCarbonOffset: IconEco,
  leadProtected: IconShieldLock,
  leadVoltalisBizdev: IconThermostat,
  leadRetentionVa: IconSentimentDissatisfied,
  leadInteractionWater: IconWaterDrop,
  leadTelecomEnergy: IconBoltRounded,
  leadTelecom: IconRouterRounded,
  leadAssurance: IconHealthAndSafety,
  leadAssuranceEmprunteur: IconRealEstateAgent,
  leadEnergyProBtob: IconBusinessCenter,
  leadEnergyProPlaceDesEnergies: IconDomain,
  leadCentury21: IconHomeWork,
  leadEddyProprietaire: IconSavings,
  leadMovingNextories: IconLocalShipping,
  leadAssuranceProSante: IconMedicalServices,
  leadAssuranceEmprunteurMeilleurTaux: IconPercent,
  leadMutuelleSantiane: IconLocalHospital,
  leadProxiserve: IconLocalFireDepartment,
}

export const productIcon = (saleKey: string, size: number) => {
  const Icon = PRODUCT_ICONS[saleKey]

  return Icon ? (
    <Icon size={size} color='currentColor' />
  ) : (
    retrieveAdditionalSalesIcons(saleKey, size, undefined, 'currentColor')
  )
}

export const productTitle = (t: TFunction, saleKey: string): string =>
  t([`additionalSales:pulse_titles.${saleKey}`, `additionalSales:titles.${saleKey}`])
